// extracted by mini-css-extract-plugin
export var productImage = "_r2-1";
export var viewLink = "_r2-2";
export var wishlistItem = "_r2-0";